import Model from './promotion_coupon_redemption.model'

let storeContent = utils.generateStore({
   Model,
   promotion__redemptions: [],
   selected_promotion__redemptions: [],
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async filterCoupons(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpointSecure({
                  resource: 'commons',
                  action: 'list',
                  data: {
                     rules: {
                        match: {
                           coupon_id: payload.id,
                           created_at: {
                              $gte: dayjs(`${data.date[0]} 00:00:00`,'DD-MM-YYYY HH:mm:SS').valueOf(),
                              $lte: dayjs(`${data.date[1]} 23:59:59`,'DD-MM-YYYY HH:mm:SS').valueOf(),
                           }
                        }
                     }
                  },
                  meta_data: {
                     service: "rewards",
                     collection: "promotion_coupon_redemption",
                  }
               })
               ctx.commit('promotion__redemptions', res.result.records);
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      handleActions(ctx, payload) {
         
      },
      async fetchData(ctx) {
         try {
            await ctx.dispatch('fetchPromotionCouponRedemption')
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
   }
};